import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
  marginBottom: '0.5rem',
};

const DashboardSection = () => {
  return (
    <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
      <Typography paragraph>
        The Dashboard serves as the central control panel in WatchNod. It provides a comprehensive and visual overview of all key metrics and account information, allowing users to efficiently manage their monitoring setup.
      </Typography>

      {/* Getting Started */}
      <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
        Getting Started
      </Typography>
      <Typography paragraph>
        To begin monitoring your servers, follow these two steps:
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            Install Node Exporter on the target server.
          </Typography>
        </li>
        <li style={listItemStyle}>
          <Typography variant="body1" component="p">
            Ensure the server’s IP is publicly accessible. Then, sign up on WatchNod and start monitoring from your dashboard.
          </Typography>
        </li>
      </ul>

      {/* Dashboard Features */}
      <Typography variant="h5" gutterBottom sx={{ mt: 5 }}>
        Dashboard Features
      </Typography>

      {/* Feature: Active Plan Details */}
      <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
        Active Plan Details
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}><Typography variant="body1">Displays your active subscription plan.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Shows the total number of Nodes and Domains in used.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Highlights remaining available IPs and the name of your plan.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Includes plan details: type, start date, and end date.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Plan management options: Upgrade, Delete or Renew the subscription.</Typography></li>
        <Typography variant="body1" color="text.secondary" >
          Note: Each plan includes a delete option to terminate it permanently.
        </Typography>
      </ul>

      {/* Feature: Uptime & Downtime Metrics */}
      <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
        Uptime & Downtime Metrics
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}><Typography variant="body1">Real-time status of nodes/domains.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Indicates overall system health.</Typography></li>
      </ul>

{/* Feature: Last 5 Transactions */}
      <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
        Last 5 Transactions
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}><Typography variant="body1">Lists your five most recent payments.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Displays date, time, amount, payment method.</Typography></li>
      </ul>


      {/* Feature: Last 5 Alerts */}
      <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
        Last 5 Alerts
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}><Typography variant="body1">Shows the most recent five alert interactions or system events.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Provides detailed alert messages and notification data.</Typography></li>
      </ul>
      
      {/* Feature: News Section */}
      <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
        News Section (WatchNod Community)
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}><Typography variant="body1">Features latest platform updates, feature releases, and maintenance announcements.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Presented in a card-based layout with headline, summary, and date.</Typography></li>
      </ul>

      {/* Feature: Last 5 Activity */}
      <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
        Last 5 Activity
      </Typography>
      <ul style={{ paddingLeft: '1.25rem' }}>
        <li style={listItemStyle}><Typography variant="body1">A log of your most recent five actions on the platform.</Typography></li>
        <li style={listItemStyle}><Typography variant="body1">Displayed in a tree-list format with detailed descriptions and timestamps.</Typography></li>
      </ul>
    </Box>
  );
};

export default DashboardSection;
